import { SkateIcon } from './SkateIcon';

/**
 * author: Google
 * id CB0C6DC2-0A4E-41C8-9E6A-9A8531F754CF
 * name skate
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/skate.svg
 * tags
 * - Sport 
 */
export const IceSkateIcon = SkateIcon;
export default IceSkateIcon